export enum MessageStatus {
  READ = 'Прочитано',
  UNREAD = 'Непрочитано',
}
